import { jsx as _jsx } from "react/jsx-runtime";
export const LinkView = ({ label }) => (_jsx("span", { style: {
        color: 'rgb(100, 69, 215)',
    }, children: label }));
//# sourceMappingURL=link_view.js.map